import type { OpportunitiesRoomToolbarProps } from './OpportunitiesRoomToolbar.types';
import { OpportunitiesRoomToolbarDesktop } from './OpportunitiesRoomToolbarDesktop';
import { OpportunitiesRoomToolbarMobile } from './OpportunitiesRoomToolbarMobile';

export function OpportunitiesRoomToolbar(props: OpportunitiesRoomToolbarProps) {
  return (
    <>
      <div className="hidden xl:block">
        <OpportunitiesRoomToolbarDesktop {...props} />
      </div>
      <div className="xl:hidden">
        <OpportunitiesRoomToolbarMobile {...props} />
      </div>
    </>
  );
}
